import { lazy, Suspense, useCallback, useState, type ReactElement } from 'react'
import { useKeySequence } from '../use-key-sequence'
import { isSeasonOpen } from '../season'

/** Typed as letters, like "boo". Twelve keys is too long to hit by accident. */
export const CHEAT_CODE = ['t', 'r', 'i', 'c', 'k', 'o', 'r', 't', 'r', 'e', 'a', 't'] as const

// The copy lives in the lazy chunk, so none of it ships to anyone who never types the word.
const CheatSheet = lazy(() => import('./cheat-sheet'))

/** Listens for the cheat word and shows the sheet. Mounted only for eligible staff. */
export function CheatCode(): ReactElement | null {
  const [open, setOpen] = useState(false)
  const toggle = useCallback((): void => {
    if (!isSeasonOpen()) return
    setOpen((was) => !was)
  }, [])
  const close = useCallback((): void => setOpen(false), [])
  useKeySequence(CHEAT_CODE, toggle)

  if (!open) return null
  return (
    <Suspense fallback={null}>
      <CheatSheet onClose={close} />
    </Suspense>
  )
}
